import { render } from "./InputFancyRadio.vue?vue&type=template&id=ccd89496&scoped=true"
import script from "./InputFancyRadio.vue?vue&type=script&lang=js"
export * from "./InputFancyRadio.vue?vue&type=script&lang=js"

import "./InputFancyRadio.vue?vue&type=style&index=0&id=ccd89496&lang=sass&scoped=true"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd89496"]])

export default __exports__